import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import actions from '../../actions/UiActions';
import trackPageView from '../../helpers/trackPageView';

// Components
import { AboutDiscoverContainer } from '../AboutDiscover/AboutDiscoverContainer';
import { DiscoveryFeed } from './DiscoveryFeed';

export const DiscoverContainerComponent = ({
    hasUserId,
    userId,
    viewer,
    isLoading,
    setIsLoading,
    relay,
}) => {
    useEffect(() => {
        trackPageView();
    }, []);

    function refetchDiscoverFeed(options = {}) {
        const { authUserId } = options;
        setIsLoading(true);
        // refetch with existing userId or authUserId (comes from auth response after login/registration)
        relay.refetch(
            { userId: userId || authUserId, hasUserId: !!userId || !!authUserId },
            null,
            () => setIsLoading(false),
            { force: true }
        );
    }

    if (hasUserId) {
        return (
            <DiscoveryFeed
                viewer={viewer}
                userId={userId}
                isLoading={isLoading}
                refetchDiscoverFeed={refetchDiscoverFeed}
            />
        );
    }
    return (
        <AboutDiscoverContainer
            hasUserId={hasUserId}
            refetchDiscoverFeed={authUserId => refetchDiscoverFeed({ authUserId })}
        />
    );
};

DiscoverContainerComponent.propTypes = {
    hasUserId: PropTypes.bool,
    userId: PropTypes.string,
    viewer: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    relay: PropTypes.object.isRequired,
    // redux
    setIsLoading: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => {
    return {
        setIsLoading: isLoadingFullPage => {
            dispatch(actions.setFullPageLoading({ isLoadingFullPage }));
        },
    };
};

export const DiscoverContainer = createRefetchContainer(
    connect(
        null,
        mapDispatchToProps
    )(DiscoverContainerComponent),
    {
        viewer: graphql`
            fragment DiscoverContainer_viewer on Viewer {
                ...DiscoveryFeed_viewer
            }
        `,
    },
    graphql`
        query DiscoverContainerRefetchQuery($userId: String!, $hasUserId: Boolean!) {
            viewer {
                ...DiscoverContainer_viewer
            }
        }
    `
);
